import React, { useEffect, useState } from "react";
import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";
import { useNavigate } from "react-router-dom";
import styles from "./AdminPage.module.css";
import {
  FaBoxOpen,
  FaListUl,
  FaTags,
  FaQuoteRight,
  FaSignOutAlt,
  FaEdit,
  FaCogs,
  // FaTruck removed
} from "react-icons/fa";

function AdminDashboardPage() {
  const navigate = useNavigate();
  const [selectedOtherPage, setSelectedOtherPage] = useState("about");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleLogout = () => {
    sessionStorage.removeItem("hider_access_token");
    navigate("/admin-login");
  };

  const handleEditOtherPage = () => {
    navigate(`/admin/pages/${selectedOtherPage}`);
  };

  return (
    <div className={styles.adminPage}>
      <Navbar />

      {/* Hero Section */}
      <div className={styles.dashboardHero}>
        <div className={styles.heroContent}>
          <h1>
            <FaCogs style={{ marginRight: "15px", color: "#00e5ff" }} />
            Admin Dashboard
          </h1>
          <p>Welcome back. Select a module to manage.</p>
        </div>
        <button onClick={handleLogout} className={styles.dashboardLogoutBtn}>
          <FaSignOutAlt /> Log Out
        </button>
      </div>

      <div className={styles.dashboardContainer}>
        <h2 className={styles.dashboardTitle}>Quick Actions</h2>

        <div className={styles.dashboardGrid}>
          {/* 1. PRODUCTS */}
          <div
            className={styles.dashboardCard}
            onClick={() => navigate("/admin/products")}
          >
            <div className={styles.iconCircle}>
              <FaBoxOpen />
            </div>
            <h3>Products</h3>
            <p>Add, edit, or remove coffee products.</p>
            <span className={styles.cardLink}>Manage Products &rarr;</span>
          </div>

          {/* 2. MENU */}
          <div
            className={styles.dashboardCard}
            onClick={() => navigate("/admin/menu")}
          >
            <div className={styles.iconCircle}>
              <FaListUl />
            </div>
            <h3>Menu</h3>
            <p>Update your café menu items.</p>
            <span className={styles.cardLink}>Manage Menu &rarr;</span>
          </div>

          {/* 3. CATEGORIES */}
          <div
            className={styles.dashboardCard}
            onClick={() => navigate("/admin/categories")}
          >
            <div className={styles.iconCircle}>
              <FaTags />
            </div>
            <h3>Categories</h3>
            <p>Organize products into categories.</p>
            <span className={styles.cardLink}>Manage Categories &rarr;</span>
          </div>

          {/* (Delivery Costs Module Removed) */}

          {/* 4. TESTIMONIALS */}
          <div
            className={styles.dashboardCard}
            onClick={() => navigate("/admin/testimonials")}
          >
            <div className={styles.iconCircle}>
              <FaQuoteRight />
            </div>
            <h3>Testimonials</h3>
            <p>Approve or edit customer reviews.</p>
            <span className={styles.cardLink}>Manage Reviews &rarr;</span>
          </div>

          {/* 5. PAGE EDITOR */}
          <div className={`${styles.dashboardCard} ${styles.specialCard}`}>
            <div className={styles.cardHeaderSpecial}>
              <div className={styles.iconCircleSpecial}>
                <FaEdit />
              </div>
              <h3>Page Editor</h3>
            </div>
            <p>Edit About Us, Roastery, etc.</p>

            <div className={styles.selectionWrapper}>
              <select
                value={selectedOtherPage}
                onChange={(e) => setSelectedOtherPage(e.target.value)}
                className={styles.fancySelect}
                onClick={(e) => e.stopPropagation()}
              >
                <option value="about">About Us</option>
                <option value="roastery">Roastery</option>
                <option value="location-mafi">Loc: Mafi</option>
                <option value="location-bherawi">Loc: Bherawi</option>
                <option value="location-hawassa">Loc: Hawassa</option>
              </select>

              <button
                className={styles.fancyBtn}
                onClick={(e) => {
                  e.stopPropagation();
                  handleEditOtherPage();
                }}
              >
                Go
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default AdminDashboardPage;
